import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const GrayArrowLeft: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
      <path d="M6.18311 1.175L2.35811 5L6.18311 8.825L4.99977 10L-0.000227928 5L4.99977 0L6.18311 1.175Z" fill="#848A95" />
    </svg>
  </SvgWrapper>
);
